import { storePagination } from '@/mixins/store'
import axios from '@axios'
import _ from 'lodash'

const getInitialState = () => ({
  products: [],
  sortingProducts: {
    sortBy: 'ncm',
    sortDesc: false,
  },
})

export default {
  namespaced: true,
  state: getInitialState(),

  getters: {
    getProductGroupedByNcm(state) {
      const ncmGrouped = _.groupBy(
        state.products || [],
        product => product.ncm
      )

      const result = Object.keys(ncmGrouped).map(key => {
        const ncmProducts = ncmGrouped[key]
        const firstItem = ncmProducts[0]

        return {
          ...firstItem,
          items: ncmProducts
        }
      })

      return result
    }
  },

  mutations: {
    ...storePagination.mutations,

    SET_PRODUCTS(state, products) {
      state.products = products
    },

    CLEAN_STATE(state) {
      const defaultData = getInitialState()
      Object.keys(defaultData).forEach(key => {
        state[key] = defaultData[key]
      })
    },
  },

  actions: {
    ...storePagination.actions,

    async fetchProductsWithoutTaxParameter({ commit }) {
      const response = await axios.get('/api/products/without-tax-parameters', {
        params: {}
      })

      commit('SET_PRODUCTS', response.data)
    },

    cleanState({ commit }) {
      commit('CLEAN_STATE')
    },
  },
}
